import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { PortalSelectMenu } from 'components/FormControls';
import { IDropdownData } from 'models/common';

require('./style.css');

interface IProps {
	entityData?: JSX.Element;
	items: IDropdownData[];
	selectedItem: number;
	onSortClick?: (groupId: number, refinementId: number) => void;
	t?: (key: string) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class SortRow extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.handleOnSortClick = this.handleOnSortClick.bind(this);
	}

	private handleOnSortClick(groupId: number, refinementId: number) {
		if (this.props.onSortClick) {
			this.props.onSortClick(groupId, refinementId);
		}
	}

	public render() {
		const { items, selectedItem, t } = this.props;

		const dropDownInputProps: any = {
			id: 'sortdropdown',
			onChange: this.handleOnSortClick,
			value: selectedItem !== null ? selectedItem : null,
			name: 'sortdropdown',
		};

		return (
			<div className="sortRow">
				<PortalSelectMenu input={dropDownInputProps} items={items} isRequired={true} label={t('SortRow_SortBy')} />
			</div>
		);
	}
}

export { SortRow };
